import { IConfig } from '@cian/config/shared';

export function getOnboardingText(config: IConfig) {
  return (
    config.get<string>('frontend-serp.cianNewbuildingChatOnboarding.Text') ?? // на чаты по ЖК на выдаче объявок
    config.get<string>('Newbuilding.CianChatOnboarding.Text') ?? // на чаты по ЖК и по объявке
    'Теперь можно написать застройщику в чате'
  );
}
